import { CustomerInvoicesTable } from "./customer-invoices-table";

export default function InvoicesScreen() {
  return (
    <div className="p-4">
      <CustomerInvoicesTable />
    </div>
  );
}
